import "bootstrap-sass";
import 'slick-carousel';

export const tabs = {
    init: function () {
        // Tabs to show
        $('.tabs a').click(function (e) {
            e.preventDefault();
            $(this).tab('show');
        });

        $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
            let newTab = e.target.getAttribute("href");
            let preTab = e.relatedTarget.getAttribute("href");

            // Fire the new Tab Slick
            $(newTab).find('.slick-slider').slick('setPosition');

            // Destroy the old Tab Slick
            // $(preTab).find('.slick-slider').slick('unslick');
        });
    },
};
